import Vue from "vue";
import Router from "vue-router";
import {
  removeToken,
  getToken,
  setToken,
  getSalaryPass,
  getPassLoginFlagCode,
  getPartnerToken,
  getCompanyCodeHeaderKey,
  getIndividualHeaderKey
} from "../utils/auth";
import store from "@/store";
import { browserUA } from "@/utils/browserUA";
import jwt_decode from "jwt-decode";
// import api from "@/api/list";

Vue.use(Router);

function beforeEnter(to, from, next) {
  if (getSalaryPass() || getPassLoginFlagCode()) {
    next();
  } else {
    store.commit("SET_SHOWSALARYPASS", true);
    if (from.path == "/") {
      next("/salary");
    } else {
      next(false);
    }
  }
}

export const routes = [
  {
    path: "/login",
    component: () => import("../views/login/LoginTelPass.vue"),
    meta: {
      title: "账号密码登录",
      noAuth: true,
    },
  },
  {
    path: "/simpleRegister",
    component: () => import("../views/simpleRegister/simpleRegistration.vue"),
    meta: {
      title: "账号邀请注册",
      noAuth: true,
    },
  },
  {
    path: "/simpleRegisterPapers",
    component: () => import("../views/simpleRegister/pictureUpload.vue"),
    meta: {
      title: "账号邀请认证",
      noAuth: true,
    },
  },
  {
    path: "/editPapers",
    component: () => import("../views/user/userInfo/editPapers.vue"),
    meta: {
      title: "证件认证",
    },
  },
  {
    path: "/telVerify",
    component: () => import("../views/login/telVerify.vue"),
    meta: {
      title: "动态密码登录",
      noAuth: true,
    },
  },
  {
    path: "/setPass",
    name: "setPass",
    component: () => import("../views/login/setPass.vue"),
    meta: {
      title: "设置密码",
      noAuth: true,
    },
  },
  {
    path: "/register",
    component: () => import("../views/login/register.vue"),
    meta: {
      title: "注册",
      noAuth: true,
    },
  },
  {
    path: "/resetTel",
    component: () => import("../views/user/userInfo/resetTel.vue"),
    meta: {
      title: "更换手机号码",
    },
  },
  {
    path: "/home",
    component: () => import("../views/index/Index.vue"),
    meta: {
      title: "首页",
      showFooter: "home",
      noAuth: true,
    },
  },
  {
    path: "/homeModule/:code",
    component: () => import("../views/index/list.vue"),
    meta: {
      title: "首页模块",
      showFooter: "home",
    },
  },
  {
    path: "/article/details",
    component: () => import("../views/index/article/details"),
    meta: {
      title: "文章详情",
    },
  },
  {
    path: "/salary",
    component: () => import("../views/salary/Index.vue"),
    meta: {
      title: "我的收益",
      showFooter: "salary",
    },
    //beforeEnter:beforeEnter
  },
  {
    path: "/salaryList",
    component: () => import("../views/salary/ListHistory.vue"),
    meta: {
      title: "历史收益",
      showFooter: "salary",
    },
    beforeEnter: beforeEnter,
  },
  {
    path: "/tranList",
    component: () => import("../views/salary/ListTranHistory.vue"),
    meta: {
      title: "历史交易",
      showFooter: "salary",
    },
    beforeEnter: beforeEnter,
  },
  {
    path: "/salaryDetail",
    component: () => import("../views/salary/Detail.vue"),
    meta: {
      title: "收益明细",
    },
    beforeEnter: beforeEnter,
  },
  {
    path: "/user",
    component: () => import("../views/user/Index.vue"),
    meta: {
      title: "个人中心",
      showFooter: "user",
    },
  },
  {
    path: "/userInfo",
    component: () => import("../views/user/userInfo/Index.vue"),
    meta: {
      title: "基本信息",
    },
  },
  {
    path: "/privacy",
    component: () => import("../views/user/userInfo/privacy.vue"),
    meta: {
      title: "隐私政策",
      noAuth: true,
    },
  },
  {
    path: "/editResume",
    component: () => import("../views/user/userInfo/editResume.vue"),
    meta: {
      title: "求职信息",
    },
  },
  {
    path: "/contractBase",
    component: () => import("../views/contract/BaseInfo.vue"),
    meta: {
      title: "基本信息",
      showFooter: "user",
    },
  },
  {
    path: "/identitySelection",
    component: () => import("../views/contract/identitySelection.vue"),
    meta: {
      title: "身份认证",
    },
  },
  {
    path: "/identity",
    component: () => import("../views/contract/IdentityAuth.vue"),
    meta: {
      title: "证件认证",
    },
  },
  {
    path: "/identityStatus",
    component: () => import("../views/contract/identityStatus.vue"),
    meta: {
      title: "认证状态",
    },
  },
  {
    path: "/contractList",
    component: () => import("../views/user/userContract/Index.vue"),
    meta: {
      title: "我的协议",
      showFooter: "user",
    },
  },
  {
    path: "/checkContract",
    component: () => import("../views/user/userContract/Check.vue"),
    meta: {
      title: "查看",
    },
  },
  {
    path: "/card",
    component: () => import("../views/user/userSalary/Card.vue"),
    meta: {
      title: "我的收款账号",
      showFooter: "user",
    },
  },
  {
    path: "/AddCardNo",
    component: () => import("../views/user/userSalary/AddCardNo.vue"),
    meta: {
      title: "添加银行卡",
    },
  },
  {
    path: "/CateCardNo",
    component: () => import("../views/user/userSalary/AddCardNo.vue"),
    meta: {
      title: "认证银行卡",
    },
  },
  {
    path: "/AddAlipay",
    component: () => import("../views/user/userSalary/AddAlipay.vue"),
    meta: {
      title: "添加支付宝",
    },
  },
  {
    path: "/AlipayEdit",
    component: () => import("../views/user/userSalary/AlipayEdit.vue"),
    meta: {
      title: "编辑支付宝",
    },
  },
  {
    path: "/addCard",
    component: () => import("../views/user/userSalary/Add.vue"),
    meta: {
      title: "确认银行卡信息",
    },
  },
  {
    path: "/news",
    component: () => import("../views/news/Index.vue"),
    meta: {
      title: "消息中心",
      showFooter: "user",
    },
  },
  {
    path: "/newsDetail",
    component: () => import("../views/news/Detail.vue"),
    meta: {
      title: "消息内容",
    },
  },
  {
    path: "/EditPassword",
    component: () => import("../views/user/userPass/Edit"),
    meta: {
      title: "修改密码",
    },
  },
  {
    path: "/article_1",
    component: () => import("../views/static/article_1"),
    meta: {
      title: "通知公告",
    },
  },
  {
    path: "/article_2",
    component: () => import("../views/static/article_2"),
    meta: {
      title: "员工须知",
    },
  },
  {
    path: "/article_3",
    component: () => import("../views/static/article_3"),
    meta: {
      title: "政策解读",
    },
  },
  {
    path: "/article_4",
    component: () => import("../views/static/article_4"),
    meta: {
      title: "常见问题",
    },
  },
  {
    path: "/article_5",
    component: () => import("../views/static/article_5"),
    meta: {
      title: "上线通知",
    },
  },
  {
    path: "/dianqianxieyi",
    component: () => import("../views/static/dianqianxieyi"),
    meta: {
      title: "电签协议",
    },
  },
  {
    path: "/validPass",
    component: () => import("../views/salary/validPass"),
    meta: {
      title: "验证密码",
    },
  },
  {
    path: "/onlineConsultation",
    component: () => import("../views/user/Consultation.vue"),
    meta: {
      title: "在线咨询",
      noAuth: true,
    },
  },
  {
    path: "/tasksList",
    component: () => import("../views/tasks/Index.vue"),
    meta: {
      title: "任务大厅",
      noAuth: true,
      showFooter:  getIndividualHeaderKey()? "home":"tasksList",
    },
  },
  {
    path: "/tasksDetail",
    component: () => import("../views/tasks/detail.vue"),
    meta: {
      title: "任务详情",
      noAuth: true,
    },
  },
  {
    path: "/myTasksList",
    component: () => import("../views/tasks/myIndex.vue"),
    meta: {
      title: "我的任务",
      showFooter: "user",
    },
  },
  {
    path: "/myTasksDetail",
    component: () => import("../views/tasks/myDetail.vue"),
    meta: {
      title: "任务详情",
    },
  },
  {
    path: "/taskDeliver",
    component: () => import("../views/tasks/deliver.vue"),
    meta: {
      title: "任务交付",
    },
  },
  {
    path: "/getCashIndex",
    component: () => import("../views/salary/getCashIndex.vue"),
    meta: {
      title: "提现",
      showFooter: "user",
    },
  },
  {
    path: "/getCashConfirm",
    component: () => import("../views/salary/getCashConfirm.vue"),
    name:'getCashConfirm',
    meta: {
      title: "提现验证",
      showFooter: "user",
    },
  },
  {
    path: "/getCashResult",
    component: () => import("../views/salary/getCashResult.vue"),
    name:'getCashResult',
    meta: {
      title: "提现结果",
      showFooter: "user",
    },
  },
  {
    path: "/cashRecord",
    component: () => import("../views/salary/cashRecord.vue"),
    meta: {
      title: "资金记录",
      showFooter: "salary",
    },
  },
  {
    path: "/partner_index",
    component: () => import("../views/partner/Index.vue"),
    meta: {
      title: "合作方首页",
      author: "partner",
      showFooter: "home",
    },
  },
  {
    path: "/partner_user_index",
    component: () => import("../views/partner/userIndex.vue"),
    meta: {
      title: "个人中心",
      author: "partner",
      showFooter: "user",
    },
  },
  {
    path: "/partner_income_index",
    component: () => import("../views/partner/incomeIndex.vue"),
    meta: {
      title: "我的佣金",
      author: "partner",
      showFooter: "salary",
    },
  },
  {
    path: "/partner_income_detail",
    component: () => import("../views/partner/incomeDetail.vue"),
    meta: {
      title: "佣金明细",
      author: "partner",
      showFooter: "salary",
    },
  },
  {
    path: "/partner_company_search",
    component: () => import("../views/partner/company_search.vue"),
    meta: {
      title: "外派公司查询",
      author: "partner",
      showFooter: "home",
    },
  },
  {
    path: "/partner_my_achieve",
    component: () => import("../views/partner/my_achieve.vue"),
    meta: {
      title: "业绩排名",
      author: "partner",
      showFooter: "home",
    },
  },
  {
    path: "/partner_login",
    component: () => import("../views/partner/login.vue"),
    meta: {
      title: "合作方登录",
      noAuth: true,
      author: "partner",
    },
  },
  {
    path: "/partner_recharge_search",
    component: () => import("../views/partner/recharge_search.vue"),
    meta: {
      title: "资金充值记录",
      author: "partner",
      showFooter: "home",
    },
  },
  {
    path: "/partner_pay_search",
    component: () => import("../views/partner/pay_search.vue"),
    meta: {
      title: "发放记录",
      author: "partner",
      showFooter: "home",
    },
  },
  {
    path: "/partner_apply_ticket",
    component: () => import("../views/partner/applyTicket.vue"),
    meta: {
      title: "我要开票",
      author: "partner",
      showFooter: "home",
    },
  },
  {
    path: "/partner_open_invoice",
    component: () => import("../views/partner/openInvoice.vue"),
    meta: {
      title: "申请开票",
      author: "partner",
      showFooter: "home",
    },
  },
  {
    path: "/choose_invoice_title",
    component: () => import("../views/partner/chooseInvoiceTitle.vue"),
    meta: {
      title: "选择发票抬头",
      author: "partner",
    },
  },
  {
    path: "/choose_invoice_data",
    component: () => import("../views/partner/chooseInvoiceData.vue"),
    meta: {
      title: "选择开票数据",
      author: "partner",
    },
  },
  {
    path: "/add_invoice_info",
    component: () => import("../views/partner/addInvoiceInfo.vue"),
    meta: {
      title: "添加发票信息",
      author: "partner",
    },
  },
  {
    path: "/invoice_records",
    component: () => import("../views/partner/recordsInvoice.vue"),
    meta: {
      title: "开票记录",
      author: "partner",
      showFooter: "home",
    },
  },
  {
    path: "/confirm_invoice",
    component: () => import("../views/partner/confirmInvoice.vue"),
    meta: {
      title: "确认发票信息",
      author: "partner",
    },
  },
  {
    path: "/credit_invoice",
    component: () => import("../views/partner/creditInvoice.vue"),
    meta: {
      title: "授信开票",
      author: "partner",
    },
  },
  {
    path: "/invoice_detail",
    component: () => import("../views/partner/invoiceDetail.vue"),
    meta: {
      title: "发票详情",
      author: "partner",
    },
  },
  {
    path: "/partner_checkContract",
    component: () => import("../views/user/userContract/Check.vue"),
    meta: {
      title: "查看",
      author: "partner",
    },
  },
  {
    path: "/partner_editPassword",
    component: () => import("../views/partner/editPassword"),
    meta: {
      title: "修改密码",
      author: "partner",
      showFooter: "user",
    },
  },
  {
    path: "/home",
    component: () => import("../views/index/Index.vue"),
    meta: {
      title: "首页",
      showFooter: "home",
      noAuth: true,
    },
  },
  {
    path: "/individual_index",
    component: () => import("../views/individual/Index.vue"),
    meta: {
      title: "个体户首页",
      showFooter: "home",
    },
  },
  {
    path: "/individual_identity",
    component: () => import("../views/individual/identity.vue"),
    meta: {
      title: "个体户证件认证",
      identity: "individual"
    },
  },
  {
    path: "/individual_video",
    component: () => import("../views/individual/video.vue"),
    meta: {
      title: "个体户视频认证",
      identity: "individual"
    },
  },
  {
    path: "/individual_newVideo",
    component: () => import("../views/individual/newVideo.vue"),
    meta: {
      title: "个体户视频认证",
      identity: "individual"
    },
  },
  {
    path: "/individual_result",
    component: () => import("../views/individual/result.vue"),
    meta: {
      title: "个体户视频认证结果",
      identity: "individual"
    },
  },
  {
    path: "/individual_signature",
    component: () => import("../views/individual/signature.vue"),
    meta: {
      title: "个体户签名认证",
      identity: "individual"
    },
  },
  {
    path: "/individual_finish",
    component: () => import("../views/individual/finish.vue"),
    meta: {
      title: "注册结果",
      identity: "individual"
    },
  },
  {
    path: "/individual_logout",
    component: () => import("../views/individual/logout.vue"),
    meta: {
      title: "申请注销",
      identity: "individual"
    },
  },
  {
    path: "/individual_logout_video",
    component: () => import("../views/individual/logoutVideo.vue"),
    meta: {
      title: "申请注销",
      identity: "individual"
    },
  },
  {
    path: "/individual_logout_result",
    component: () => import("../views/individual/logoutResult.vue"),
    meta: {
      title: "注销结果",
      identity: "individual"
    },
  },
  {
    path: "/individual_list",
    component: () => import("../views/individual/list.vue"),
    meta: {
      title: "个体户列表",
      showFooter: "tasksList"
    },
  },
  {
    path: "/individual_info",
    component: () => import("../views/individual/info.vue"),
    meta: {
      title: "个体户明细",
    },
  },
  {
    path: "/individual_contractList",
    component: () => import("../views/individual/contract.vue"),
    meta: {
      title: "个体户电签",
    },
  },
  {
    path: "/individual_baseInfo",
    component: () => import("../views/individual/baseInfo.vue"),
    meta: {
      title: "个体户确认信息",
    },
  },
  {
    path: "/individual_choose",
    component: () => import("../views/individual/choose.vue"),
    meta: {
      title: "选择模式",
    },
  },
  { path: '/', redirect: getIndividualHeaderKey()?'/individual_index':'/home'},
];

//import wx from 'weixin-js-sdk'
// add route path
routes.forEach((route) => {
  route.path = route.path || "/" + (route.name || "");
});

const router = new Router({
//  mode: "history", //后端支持可开
  base: process.env.BASE_URL,
  routes
});


let url = window.location.href;

router.beforeEach((to, from, next) => {
  //进入路由时将进入标志设置为true,并将请求数重置,使loading效果只在进入页面时展示
  store.commit("RESET_REQUEST_COUNTER");
  store.commit("SET_ENTER_ROUTE_LOADING", true);
  //个体户路由的单独处理
  if(getIndividualHeaderKey()) {
    // 跳转到个体户注册的首页
    if (to.path === "/home") {
      next({ path: "/individual_index" });
    }else{
      next();
    }

    if (to.path === "/contractList") {
      next({ path: "/individual_contractList" });
    }else{
      next();
    }
    return;
  }

  if (to.meta.author == "partner") {
    if (
        typeof getPartnerToken() != "undefined" &&
        getPartnerToken() != "undefined" &&
        getPartnerToken()
    ) {
      const timeLeft =
          store.getters.partnerJwtDecode.exp - Math.round(new Date() / 1000);
      if (timeLeft <= 0) {
        if (to.meta.noAuth) {
          next();
        } else {
          store.commit("SET_ENTERROUTE", to.fullPath); //记录进入路由 用于在登录后的重定向

          authAction(to, next, "partner");
        }
      } else {
        if (to.path === "/partner_login") {
          next({ path: "/partner_index" });
        } else {
          next();
        }
      }
    } else {
      if (to.meta.noAuth) {
        next();
      } else {
        store.commit("SET_ENTERROUTE", to.fullPath); //记录进入路由 用于在登录后的重定向
        authAction(to, next, "partner");
      }
    }
    return;
  } 
  if(!(to.meta.author == "partner"||getIndividualHeaderKey())) {
    let token = to.query.token;
    if (token) {
      setToken(token);
      store.commit("SET_TOKEN", token);
      store.commit("SET_JWTDECODE", jwt_decode(token));
    }
    if (
        typeof getToken() != "undefined" &&
        getToken() != "undefined" &&
        getToken()
    ) {
      const timeLeft =
          store.getters.jwtDecode.exp - Math.round(new Date() / 1000);
      if (timeLeft <= 0) {
        if (to.meta.noAuth) {
          next();
        } else {
          store.commit("SET_ENTERROUTE", to.fullPath); //记录进入路由 用于在登录后的重定向
          authAction(to, next);
        }
      } else {
        if(!store.getters.userInfo){
          store.dispatch("getUserInfo");
        }
        if(sessionStorage.getItem('identityFlag')){  //免登的情况处理跳转
          if (to.path === "/login") {
            next({ path: "/home" });
          } else {
            next();
          }
        }else{
             next();
        }
      }
    } else {
      if (to.meta.noAuth) {
        next();
      } else {
        store.commit("SET_ENTERROUTE", to.fullPath); //记录进入路由 用于在登录后的重定向
        authAction(to, next);
      }
    }
  }
});

router.afterEach((to) => {

  let companyCodeHeader=getCompanyCodeHeaderKey(); // 从响应头中读取
  if(companyCodeHeader!=null && companyCodeHeader!="null"){
    store.dispatch("GetCustomCompanyInfo", companyCodeHeader); // 获取定制化信息
  }
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  let ecompanyCode = to.query.ecompanyCode;
  let ecompanyCode2 = to.query.ecompanyCode;
  if (ecompanyCode) {
    store.commit("SET_ECOMPANYCODE", ecompanyCode);
  } else {
    let ocompanyCode = to.query.ocompanyCode;
    if (ocompanyCode) {
      store.commit("SET_OCOMPANYCODE", ocompanyCode);
    }
  }
  if (
    (ecompanyCode2 == null || ecompanyCode2 == "") &&
    companyCodeHeader != null &&
    companyCodeHeader != "null"
  ) {
    // 定制化企业将企业编码配置在请求头中
    ecompanyCode2 = companyCodeHeader;
  }
  if(ecompanyCode2){
    store.commit("SET_PLATFORM_NAME", "灵工平台");
  }
  
});

function authAction(to, next, type) {
  let loginPath;
  let wechatAutoLogin;

  if (type == "partner") {
    loginPath = "/partner_login";
    wechatAutoLogin = "partnerWechatAutoLogin";
  } else {
    if (to.path == "/login?ecompanyCode=SH") {
      loginPath = to.path;
    } else {
      loginPath = "/login";
    }

    wechatAutoLogin = "wechatAutoLogin";
  }
  browserUA().then((browserType) => {
    if (browserType == "MINI") {
      if (
          url.indexOf("?") > 0 &&
          url.indexOf("#") > 0 &&
          url.indexOf("=") > 0
      ) {
        let query = url
            .split("?")[1]
            .split("#")[0]
            .split("=");
        if (query[0] == "openId") {
          store.commit("SET_WXMINIOPENID", query[1]);
          store
              .dispatch("getMiniToken", query[1])
              .then(() => {
                next({
                  path: to.fullPath,
                });
              })
              .catch(() => {
                next({ path: loginPath });
              });
        } else {
          next({ path: loginPath });
        }
      } else {
        next({ path: loginPath });
      }
    } else if (browserType == "WX") {
      store
          .dispatch(wechatAutoLogin, to.fullPath)
          .then((res) => {
            if (res == true) {
              if (type == "partner") {
                next({ path: loginPath });
              } else {
                if (to.path == "/contractList") {
                  next({
                    path: "/telVerify",
                    query: { status: "1" },
                  });
                } else {
                  next({ path: loginPath });
                }
              }
            } else {
              if (res.status != "200") {
                removeToken();
                if (url.indexOf("&state=STATE") != -1) {
                  let url1 = url.substring(0, url.indexOf("code=") - 1);
                  let url3;

                  if (type == undefined && to.path == "/contractList") {
                    url3 = url1 + "#/telVerify?status=1";
                  } else {
                    url3 = url1 + `#${loginPath}`;
                  }

                  window.location.replace(url3);
                } else {
                  if (type == undefined && to.path == "/contractList") {
                    next({
                      path: "/telVerify",
                      query: { status: "1" },
                    });
                  } else {
                    next({ path: loginPath });
                  }
                }
              } else {
                next({ path: to.fullPath });
              }
            }
          })
          .catch(() => {
            removeToken();
            if (url.indexOf("&state=STATE") != -1) {
              let url1 = url.substring(0, url.indexOf("code=") - 1);
              let url3 = url1 + `#${loginPath}`;
              next({ path: url3 });
            } else {
              next({ path: loginPath });
            }
          });
    } else if (browserType == "androidAPP" || browserType == "iosAPP") {
      store
          .dispatch("appAutoLogin", to.fullPath)
          .then((res) => {
            if (res == true) {
              if (type == "partner") {
                next({ path: loginPath });
              } else {
                next();
                // if (to.path == "/contractList") {
                //   next({
                //     path: "/telVerify",
                //     query: { status: "1" },
                //   });
                // } else {
                //   next({ path: loginPath });
                // }
              }
            } else {
              if (res.status != "200") {
                removeToken();
                if (url.indexOf("&state=STATE") != -1) {
                  let url1 = url.substring(0, url.indexOf("code=") - 1);
                  let url3;

                  if (type == undefined && to.path == "/contractList") {
                    url3 = url1 + "#/telVerify?status=1";
                  } else {
                    url3 = url1 + `#${loginPath}`;
                  }

                  window.location.replace(url3);
                } else {
                  if (type == undefined && to.path == "/contractList") {
                    next({
                      path: "/telVerify",
                      query: { status: "1" },
                    });
                  } else {
                    next({ path: loginPath });
                  }
                }
              } else {
                next({ path: to.fullPath });
              }
            }
          })
          .catch(() => {
            removeToken();
            if (url.indexOf("&state=STATE") != -1) {
              let url1 = url.substring(0, url.indexOf("code=") - 1);
              let url3 = url1 + `#${loginPath}`;
              next({ path: url3 });
            } else {
              next({ path: loginPath });
            }
          });
    } else {
      next({ path: loginPath });
    }
  });
}

export { router };
